import { privacyContent } from "../data/privacy-content";
import SEO from "@/components/SEO";

export default function Privacy() {
  return (
    <>
      <SEO
        title="Privacy Policy | Motosport Software"
        description="Read the Motosport Software privacy policy covering how we collect, use, and protect your information."
        url="https://motosportsoftware.com/privacy"
      />
      <main className="mx-auto max-w-3xl px-4 py-12 sm:px-6">
        <h1 className="text-[36px] font-bold leading-tight tracking-tight text-[#1F2A3A] mb-8">
          Privacy Policy
        </h1>
        <div className="prose prose-lg max-w-none">
          {privacyContent.sections.map((section, index) => (
            <div key={index} className="mb-8">
              <h2 className="text-2xl font-bold text-[#1F2A3A] mb-4">{section.title}</h2>
              {section.paragraphs.map((paragraph, pIndex) => (
                <p key={pIndex} className="mb-4 text-[#525A68]">
                  {paragraph}
                </p>
              ))}
            </div>
          ))}
        </div>
      </main>
    </>
  );
}
